import React from "react";

const ServiceContextBanners = ({
  editSession,
  serviceTitle,
  assessingNurse,
  selectedSchool,
  onChangeService,
}) => {
  const selectedSchoolLabel = selectedSchool
    ? `${selectedSchool.urn ? `${selectedSchool.urn} - ` : ""}${
        selectedSchool.name || ""
      }`
    : "";

  return (
    <>
      {editSession && (
        <div className="mx-4 mb-4 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-amber-700">
              Editing form
            </p>
            <p className="text-lg font-bold text-slate-900 font-fatfrank">
              {editSession.source === "admin" &&
              editSession.record?.status === "submitted"
                ? "Update and resend this submitted form"
                : "Update this saved form"}
            </p>
          </div>
          <button
            type="button"
            className="inline-flex items-center justify-center rounded-lg border border-amber-400 px-4 py-2 text-sm font-semibold text-amber-800 transition hover:bg-amber-100"
            onClick={onChangeService}
          >
            Cancel edit
          </button>
        </div>
      )}

      <div className="mx-4 mb-4 rounded-2xl border border-sas-primary/20 bg-sas-primary/5 px-4 py-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-sas-primary">
            Service
          </p>
          <p className="text-lg font-bold text-slate-900 font-fatfrank capitalize">
            {serviceTitle}
          </p>
          {assessingNurse ? (
            <p className="mt-1 text-xs font-medium text-slate-600 font-montserrat">
              Assessing nurse: {assessingNurse}
            </p>
          ) : null}
          {selectedSchoolLabel ? (
            <p className="mt-1 text-xs font-medium text-slate-600 font-montserrat">
              School: {selectedSchoolLabel}
            </p>
          ) : null}
        </div>
        <button
          type="button"
          className="inline-flex items-center justify-center rounded-lg border border-sas-primary px-4 py-2 text-sm font-semibold text-sas-primary transition hover:bg-sas-primary hover:text-white"
          onClick={onChangeService}
        >
          {editSession ? "Cancel edit" : "Change service"}
        </button>
      </div>
    </>
  );
};

export default ServiceContextBanners;
